import React, { useMemo } from 'react';
import { Autocomplete, TextField, Checkbox } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const POSITION_GROUPS = [
  {
    id: '6f2689d3b1784a19b10a9ba70601d083',
    name: 'Local Chapter Officers',
  },
  {
    id: '03fdb191d5c54f16b4fdde93cf09b5d6',
    name: 'SPD Chapter Officers',
  },
  {
    id: 'af1ef8d3dac94fe5890be291cb95cf21',
    name: 'Local Project Chairs',
  },
  {
    id: 'past_state_presidents',
    name: 'Past State Presidents',
  },
];

interface PositionGroup {
  id: string;
  name: string;
}

interface LeadershipPositionGroupsFilterProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  required?: boolean;
}

const LeadershipPositionGroupsFilter: React.FC<
  LeadershipPositionGroupsFilterProps
> = ({ value, onChange, disabled = false, required = false }) => {
  const selected = useMemo(() => {
    if (!value) return [];
    const ids = value
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
    return POSITION_GROUPS.filter((g) => ids.includes(g.id));
  }, [value]);

  const handleChange = (_event: any, newValue: PositionGroup[]) => {
    onChange(newValue.map((g) => g.id).join(','));
  };

  return (
    <Autocomplete
      multiple
      id="leadership-position-groups-filter"
      options={POSITION_GROUPS}
      disableCloseOnSelect
      disabled={disabled}
      value={selected}
      onChange={handleChange}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      renderOption={(props, option, { selected: sel }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={sel}
          />
          {option.name}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Position groups"
          placeholder="Select groups..."
          required={required}
          size="small"
        />
      )}
    />
  );
};

export default LeadershipPositionGroupsFilter;
